// extracted by mini-css-extract-plugin
module.exports = {"content":"AppImportantMatters_content__i7_DL","title":"AppImportantMatters_title__W8u55"};